import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { AlertTriangle, ChevronRight } from "lucide-react";

export default function TodayAbsences() {
  const [rows, setRows] = useState(null);
  const today = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    const fetchDay = () => api.get("/admin/appel-day", { params: { date: today } }).then(({ data }) => setRows(data.rows)).catch(() => setRows([]));
    fetchDay();
    const timer = setInterval(fetchDay, 60000);
    return () => clearInterval(timer);
  }, [today]);

  if (!rows) return null;
  const absents = rows.filter((r) => r.status === "absent");
  const nonJust = absents.filter((r) => !r.justified);
  const lates = rows.length - absents.length;

  return (
    <Link
      to="/admin/appels"
      className="mt-8 flex flex-wrap items-center justify-between gap-4 bg-white border border-[var(--parchment-2)] hover:border-[var(--maroon)] transition-colors px-6 py-4"
      data-testid="today-absences-widget"
    >
      <div className="flex items-center gap-3">
        <AlertTriangle size={18} className={nonJust.length > 0 ? "text-[var(--late)]" : "text-[var(--ok)]"} />
        <div>
          <div className="eyebrow">Absences aujourd'hui — toutes classes</div>
          <div className="mt-1 text-sm font-mono-spec" data-testid="today-absences-counts">
            <span className="text-[var(--late)] font-semibold">{absents.length} absence{absents.length > 1 ? "s" : ""}</span>
            {" · "}
            <span className="text-[var(--just)] font-semibold">{lates} retard{lates > 1 ? "s" : ""}</span>
            {nonJust.length > 0 && (
              <span className="ml-2 px-2 py-0.5 bg-[var(--late)] text-white text-xs">{nonJust.length} non justifiée{nonJust.length > 1 ? "s" : ""}</span>
            )}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-4 text-xs text-[var(--ink-soft)]">
        {nonJust.slice(0, 4).map((r) => (
          <span key={`${r.student_id}-${r.slot}`} className="hidden md:inline">
            {r.student.last_name.toUpperCase()} {r.student.first_name} ({r.class?.name || "—"})
          </span>
        ))}
        <span className="inline-flex items-center gap-1 text-[var(--maroon)] font-medium">
          Voir le bulletin complet <ChevronRight size={14} />
        </span>
      </div>
    </Link>
  );
}
